enum VendorCustomerStateEnum {
  CreateApiCredentials = "CreateApiCredentials",
  ToActivate = "ToActivate",
  Live = "Live",
}

export default VendorCustomerStateEnum;
